import "./addressInput.css";

const AddressInput = ({ value, checked, onchange, name }) => {
  return (
    <div className="relative flex items-center justify-center w-4 h-4 rounded-full border border-logoRed ">
      <input
        type="radio"
        className="relative z-20 opacity-0 cursor-pointer"
        name={name}
        value={value}
        onChange={onchange}
        checked={checked}
      />
      <div className={`w-full h-full rounded-full  absolute top-0 z-10`}></div>
    </div>
  );
};

export default AddressInput;
